import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { useMemo } from "react";
import { DialogContent, Grid } from "@material-ui/core";
import insurancesService from "../../../services/insurances.service";
import { useSelector } from "react-redux";

const initialValues = {
  name: "",
  description: "",
  url: "",
  type: null,
  isActive: true,
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  description: yupSchema.description,
  url: yupSchema.url,
});

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();
  const { initials } = useSelector((s) => s.app);

  const form = useMemo(
    () => [
      {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        name: "name",
        label: "نام",
        autoFocus: true,
      },
      {
        _type: "autocomplete",
        _wrapper: (props) => <Grid item xs={12} sm={6} {...props} />,
        _empty: undefined,
        name: "type",
        options: initials?.enums?.insuranceType || [],
        label: "نوع",
        valueSelector: "value",
        labelSelector: "title",
        disableClearable: true,
      },
      {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        name: "url",
        label: "لینک",
        helperText:
          "برای جایگذاری کد ملی در لینک از {nationalCode} استفاده کنید.",
      },
      {
        _type: "textField",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        name: "description",
        multiline: true,
        rows: 4,
        label: "توضیحات",
      },
      {
        _type: "switch",
        _wrapper: (props) => <Grid item xs={12} {...props} />,
        name: "isActive",
        label: "فعال",
      },
    ],
    [initials]
  );

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await insurancesService.editInsurance(data.id, model);
    } else {
      op = await insurancesService.createInsurance(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "بیمه",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
}
